import Icon from "./Icon";

export default function HeroHeader({ loading }) {
  return (
    <div className="relative overflow-hidden rounded-2xl border bg-white">
      <div className="absolute inset-0 bg-gradient-to-r from-sky-500/12 via-purple-500/12 to-emerald-500/12" />
      <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-sky-500/10 blur-2xl" />
      <div className="absolute -bottom-24 -left-24 w-64 h-64 rounded-full bg-purple-500/10 blur-2xl" />

      <div className="relative p-5 flex items-start justify-between gap-4">
        <div>
          <div className="inline-flex items-center gap-2 text-xs font-medium px-2.5 py-1 rounded-full bg-white/70 border">
            <Icon name="spark" className="w-4 h-4" />
            Admin • Clinic access control
          </div>

          <h1 className="mt-2 text-2xl font-semibold text-slate-900">
            Users &amp; Permissions
          </h1>

          <p className="text-sm text-slate-600 mt-1">
            Add staff users, assign roles, and manage permissions.
          </p>
        </div>

        {loading && (
          <div className="inline-flex items-center gap-2 px-3 py-2 rounded-xl border bg-white/70">
            <span className="w-2 h-2 rounded-full bg-sky-500 animate-pulse" />
            <span className="text-sm text-slate-700">Loading…</span>
          </div>
        )}
      </div>
    </div>
  );
}
